export default {
  en: {
    setting: 'Setting'
  },
  th: {
    setting: 'การตั้งค่า'
  }
}
